import { render, staticRenderFns } from "./InfoMediaDeleted.vue?vue&type=template&id=034c129e&scoped=true"
import script from "./InfoMediaDeleted.vue?vue&type=script&lang=js"
export * from "./InfoMediaDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034c129e",
  null
  
)

export default component.exports